import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConversionErrorDialogData {
  title: string;
  message: string;
  details?: string;
}

@Component({
  selector: 'app-conversion-error-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p>{{ data.message }}</p>
      <div *ngIf="data.details" class="error-details">
        <strong>{{ 'BACKOFFICE.HOLDED_TO_SAGE.ERRORS.ERROR_DETAILS' | translate }}</strong>
        <pre>{{ data.details }}</pre>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">
        {{ 'BACKOFFICE.HOLDED_TO_SAGE.ERRORS.CANCEL' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="onContinue()">
        {{ 'BACKOFFICE.HOLDED_TO_SAGE.ERRORS.CONTINUE' | translate }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    .error-details {
      margin-top: 16px;
      padding: 12px;
      background-color: #f5f5f5;
      border-radius: 4px;
    }

    .error-details pre {
      margin: 8px 0 0 0;
      font-size: 12px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }

    mat-dialog-content {
      min-width: 300px;
    }
  `]
})
export class ConversionErrorDialogComponent2025 {
  constructor(
    public dialogRef: MatDialogRef<ConversionErrorDialogComponent2025>,
    @Inject(MAT_DIALOG_DATA) public data: ConversionErrorDialogData
  ) { }

  onContinue(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
